import api from './api';
import _ from 'lodash';

export default {
  getDocuments(ids) {
    let params = {
      filters: {
        where: [['entity_id', '=', ids.id]]
      }
    };
    if (!_.isNull(ids.referral_id)) {
      params.filters.orWhere = [['entity_id', '=', ids.referral_id]];
    }
    // console.log(params)

    return new Promise((resolve, reject) => {
      api
        .get('document', { params })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  upload(files, customerId, referralId) {
    const data = new FormData();
    const entityId = customerId || referralId || null;
    data.append('entity_id', entityId);
    data.append('document', files[0]);

    const path = _.isNull(customerId) ? 'document/referral' : 'document';

    return new Promise((resolve, reject) => {
      api
        .post(path, data, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  delete(id) {
    return api.delete(`document/${id}`);
  }
};
